export default __webpack_public_path__ + "static/media/Roboto-Regular.03523cf5.ttf";